import {
  BarcodeScanner
} from '@capacitor-mlkit/barcode-scanning';
import { scan as defaultScan } from '~/utils/CapacitorBarcodeScanner.default';

export async function iosScan() {
  const settingsStore = useSettingsStore();
	
  if (settingsStore._settings.showScannerButton) {
    return await defaultScan();
  } else {
    try {
      const result = await BarcodeScanner.scan();

      if (result.barcodes.length) {
        return result.barcodes[0].displayValue;
      }
    } catch {
      return; 
    }
  }
}